export var CareVisitType;
(function (CareVisitType) {
    CareVisitType["HOSPITALIZATION"] = "HOSPITALIZATION";
    CareVisitType["HOSPICE"] = "HOSPICE";
    CareVisitType["LONG_TERM_CARE_FACILITY"] = "LONG_TERM_CARE_FACILITY";
})(CareVisitType || (CareVisitType = {}));
